import { ConflictError, UnauthorizedError } from "../errors/http_errors";
import { User } from "../models/user";

async function fetchData(input: RequestInfo, init?: RequestInit) {
  const response = await fetch(input, init);

  if (response.ok) {
    return response;
  } else {
    const errorBody = await response.json();
    const errorMessage = errorBody.error;
    if (response.status === 401) {
      throw new UnauthorizedError(errorMessage);
    } else if (response.status === 409) {
      throw new ConflictError(errorMessage);
    } else {
      throw Error(
        "Request failed with status: " +
          response.status +
          " message: " +
          errorMessage
      );
    }
  }
}

export async function getLoggedInUser(): Promise<User> {
  const response = await fetchData(
    `${process.env.REACT_APP_API_URL}/api/users`,
    { method: "GET", credentials: "include" }
  );
  return response.json();
}

export interface SignUpCredentials {
  firstName: string;
  lastName: string;
  email: string;
  userName: string;
  password: string;
}

export async function fetchUser(): Promise<User> {
  const response = await fetchData(
    `${process.env.REACT_APP_API_URL}/api/users/profile`,
    { method: "GET", credentials: "include" }
  );
  return response.json();
}

export async function signUp(credentials: SignUpCredentials): Promise<User> {
  const response = await fetchData(
    `${process.env.REACT_APP_API_URL}/api/users/signup`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    }
  );
  return response.json();
}

export interface LoginCredentials {
  userName: string;
  password: string;
}

export async function login(credentials: LoginCredentials): Promise<User> {
  const response = await fetchData(
    `${process.env.REACT_APP_API_URL}/api/users/login`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    }
  );
  return response.json();
}

export async function logout() {
  await fetchData(`${process.env.REACT_APP_API_URL}/api/users/logout`, {
    method: "POST",
    credentials: "include",
  });
}


export async function updateUser(credentials: User): Promise<User> {
  const response = await fetchData(
    `${process.env.REACT_APP_API_URL}/api/users/profile`,
    {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    }
  );
  return response.json();
}
